<template>
  <div class="login-form">
    <div class="login-header">
      <h1 class="login-title" :style="getPrimaryColor">
        <i class="ph ph-user-switch"></i> Forgot Password
      </h1>
    </div>

    <div class="divider">
      <span class="line"></span>
      <span class="line"></span>
    </div>
    <el-form
      v-if="currentForm === 'default' && !isSettedPassword"
      class="log-form"
      :model="verification"
      ref="verification"
      @submit.native.prevent="verifyEmail('verification')"
    >
      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input
          v-model="verification.email"
          placeholder="Email or Mobile"
          autocomplete="off"
        ></el-input>
        <p class="error" v-if="getErrors && getErrors.email">
          {{ getErrors.verification_email }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row space-between">
          <el-button
            type="primary"
            size="medium"
            round
            native-type="button"
            class="login-button full-width"
            @click="verifyEmail('verification')"
            :loading="submitLoading"
            :style="getButtonStyles"
          >
            Click here to verify
          </el-button>
        </div>

        <div class="nav-link text-right">
          <router-link
            to="/signin/tenant"
            class="fw-bold"
            :style="getPrimaryColor"
          >
            Back to SignIn
          </router-link>
        </div>
      </el-form-item>

      <p
        class="error"
        v-if="getCompaniesByEmail && !getCompaniesByEmail.status"
      >
        {{ getCompaniesByEmail.message }}
      </p>
    </el-form>

    <!-- Verified Sign-In Form -->
    <el-form
      v-if="currentForm === 'VERIFIED' && !isSettedPassword"
      :model="signin"
      ref="signin"
      class="log-form"
      @submit.native.prevent="submitForm('signin')"
    >
      <h3>Welcome {{ getUserNameOfUser }}!</h3>

      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input
          v-model="signin.email"
          placeholder="Email or Mobile"
          disabled
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item class="mb-1" prop="workspace">
        Workspace <span class="text-danger">*</span>
        <el-select
          v-model="signin.workspace"
          filterable
          placeholder="Select"
          style="width: 100%"
        >
          <el-option
            v-for="item in getWorkspaceList"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          ></el-option>
        </el-select>
        <p class="error" v-if="getErrors && getErrors.workspace">
          {{ getErrors.workspace }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row space-between">
          <el-button
            type="primary"
            size="medium"
            round
            native-type="button"
            class="login-button full-width"
            @click="submitForm('signin')"
            :loading="submitLoading"
            :style="getButtonStyles"
          >
            Send Verfication Code
          </el-button>
        </div>
        <div class="nav-link text-right">
          <router-link
            to="/signin/tenant"
            class="fw-bold"
            :style="getPrimaryColor"
          >
            Back to SignIn
          </router-link>
        </div>
      </el-form-item>

      <p
        class="error"
        v-if="getCompaniesByEmail && !getCompaniesByEmail.status"
      >
        {{ getCompaniesByEmail.message }}
      </p>
    </el-form>

    <div v-if="isSettedPassword && !isForgotPassword">
      <!-- set password -->
      <el-form ref="form" @submit.native.prevent>
        <el-form-item label="Enter OTP">
          <el-input v-model="otp" placeholder="Enter otp"></el-input>
        </el-form-item>
        <!-- <span style="color: #5cb85c" v-if="successMessages.length">
                  {{ successMessages }}
                </span> -->
        <el-form-item label="Set Password" prop="password">
          <div class="password-input-wrapper">
            <el-input
              v-model="setPassword"
              placeholder="Set Password"
              :type="passwordType"
              autocomplete="off"
            ></el-input>

            <span
              class="password-toggle"
              @click="
                passwordType = passwordType === 'password' ? 'text' : 'password'
              "
            >
              {{ passwordType === "password" ? "SHOW" : "HIDE" }}
            </span>
          </div>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="password">
          <div class="password-input-wrapper">
            <el-input
              v-model="conformPassword"
              placeholder="Confirm Password"
              :type="confirmPasswordType"
              autocomplete="off"
            ></el-input>

            <span
              class="password-toggle"
              @click="
                confirmPasswordType =
                  confirmPasswordType === 'password' ? 'text' : 'password'
              "
            >
              {{ confirmPasswordType === "password" ? "SHOW" : "HIDE" }}
            </span>
          </div>
        </el-form-item>

        <span v-if="passwordErrors.length" style="color: red">
          {{ passwordErrors.join(",") }}
        </span>
        <el-form-item>
          <div class="forgot-login-row space-between mt-1">
            <el-button
              type="primary"
              size="medium"
              round
              native-type="button"
              class="login-button full-width"
              @click="checkPassword"
              :disabled="!otp"
              :loading="submitLoading"
              :style="getButtonStyles"
            >
              Reset Password
            </el-button>
          </div>

          <div class="d-flex justify-between align-center">
            <div class="nav-link text-right">
              <router-link
                to="/signin/tenant"
                class="fw-bold"
                :style="getPrimaryColor"
              >
                Back to SignIn
              </router-link>
            </div>

            <div
              class="nav-link text-right forgot-password-link"
              @click="resendVerificationCode"
              :class="{ disabled: isDisabled }"
              :style="{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.5 : 1,
              }"
            >
              {{ buttonText }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserHelper from "@/mixins/UserHelper";
import WhiteLabelConfig from "@/config/app";
import CustomizationLayer from "@/mixins/CustomizationLayer";
import CryptoJS from "crypto-js";
import config from "@/config/app";

const ENC_KEY = config.URL_ENC_KEY;

export default {
  data() {
    return {
      isDisabled: false,
      timer: 30,
      intervalId: null,

      isSettedPassword: false,
      isForgotPassword: false,
      isEmailOpted: true,

      email: "",
      password: "",
      passwordErrors: [],
      passwordError: "",
      confirmPasswordType: "password",
      otp: "",
      setPassword: "",
      conformPassword: "",
      otpFromLink: false,

      existedSigninEmail: "",
      password_rules: [
        {
          message:
            "Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol",
          regex:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
        },
      ],

      company_info: {},
      application_config: {},
      currentForm: "default",
      verification: { email: "" },
      signin: { email: "", password: "", workspace: "" },
      passwordType: "password",
      submitLoading: false,
      getErrors: null,

      bootTried: false,
      bootError: "",
      contactDetails: null,
      resendDetails: null,
      successMessages: "",
      VerificationErrors: "",
      loading: false,
    };
  },

  mixins: [UserHelper, CustomizationLayer],

  computed: {
    ...mapGetters("company", ["getCompaniesByEmail", "getContactLoginSlug"]),
    ...mapGetters("auth", ["getAuthenticationStatus", "getUserSignInErrors"]),
    ...mapGetters("applicationUsers", [
      "getUserVerifyDetails",
      "getUserEmailVerifyDetails",
      "getUserEmailVerificationErrors",
      "getUserSignInVerify",
      "getForgotAndResendVerify",
      "getForgotAndResendVerifyError",
    ]),

    getUserNameOfUser() {
      const c = this.getCompaniesByEmail;
      const first =
        c && c.status && Array.isArray(c.companies) && c.companies[0];
      return first
        ? `${first.first_name || ""} ${first.last_name || ""}`.trim()
        : "";
    },
    getEmail() {
      const c = this.getCompaniesByEmail;
      const first =
        c && c.status && Array.isArray(c.companies) && c.companies[0];
      return first?.email || "";
    },
    getWorkspaceList() {
      const c = this.getCompaniesByEmail;
      return c && c.status && Array.isArray(c.companies) ? c.companies : [];
    },
    isEmailValid() {
      const v = (this.verification.email || "").trim().toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(v);
    },
    buttonText() {
      // Always show the same label; timer only changes when cooling down
      if (this.isDisabled) {
        return `Resend ${this.isEmailOpted ? "verification OTP" : "OTP"} (${
          this.timer
        }s)`;
      }
      return `Resend ${this.isEmailOpted ? "verification OTP" : "OTP"}`;
    },
    hasSingleWorkspace() {
      const list = this.getWorkspaceList || [];
      return Array.isArray(list) && list.length === 1;
    },
    singleWorkspaceId() {
      return this.hasSingleWorkspace ? this.getWorkspaceList[0]._id : "";
    },
  },

  watch: {
    getWorkspaceList(newList) {
      const list = Array.isArray(newList) ? newList : [];
      if (list.length === 1) {
        this.$nextTick(() => (this.signin.workspace = list[0]._id));
        return;
      }
      if (!list.find((w) => w._id === this.signin.workspace)) {
        this.signin.workspace = "";
      }
    },
    currentForm(val) {
      if (val === "VERIFIED" && this.hasSingleWorkspace) {
        this.$nextTick(() => (this.signin.workspace = this.singleWorkspaceId));
      }
    },
    $route() {
      if (this.intervalId) clearInterval(this.intervalId);
      this.tryBootstrap();
    },
  },

  mounted() {
    this.$store.commit("company/resetCompaniesByEmail");
    this.application_config = WhiteLabelConfig;
    this.tryBootstrap();
  },

  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },

  methods: {
    normalizeLogin(v) {
      return (v || "").toString().trim().toLowerCase().replace(/\s+/g, "");
    },
    isEmailFmt(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || "");
    },
    isINPhone(v) {
      return /^(?:\+?91)?\d{10}$/.test((v || "").replace(/\s+/g, ""));
    },
    safeDecode(v) {
      try {
        return decodeURIComponent(v || "");
      } catch {
        return v || "";
      }
    },

    hasOpenSSLPrefix(b64) {
      return typeof b64 === "string" && b64.startsWith("U2FsdGVkX1");
    },
    normalizeB64ForCrypto(b64 = "") {
      let s = "";
      try {
        s = decodeURIComponent(b64 || "");
      } catch {
        s = b64 || "";
      }
      s = s.replace(/ /g, "+").replace(/-/g, "+").replace(/_/g, "/");
      const pad = s.length % 4;
      if (pad) s += "=".repeat(4 - pad);
      return s;
    },
    decryptAES(cipherText) {
      try {
        if (!cipherText) return "";
        if (!ENC_KEY) return "";
        const norm = this.normalizeB64ForCrypto(cipherText);
        const bytes = CryptoJS.AES.decrypt(norm, ENC_KEY);
        const out = bytes.toString(CryptoJS.enc.Utf8);
        return out || "";
      } catch {
        return "";
      }
    },
    looksEncrypted(v) {
      if (!v || typeof v !== "string") return false;
      const s = v.trim();
      if (this.hasOpenSSLPrefix(s)) return true;
      if (s.length < 16) return false;
      if (/\s/.test(s)) return false;
      return /^[A-Za-z0-9+/_-]+=*$/.test(s);
    },
    maybeDecrypt(v) {
      if (!v) return "";
      if (this.looksEncrypted(v)) {
        const dec = this.decryptAES(v);
        if (dec) return dec;
      }
      return v;
    },
    decryptFromUrl(token) {
      return this.decryptAES(token);
    },

    tryBootstrap() {
      if (this.bootTried) return;
      this.bootTried = true;
      const q = this.$route?.query || {};
      if (q.t || q.token || q.c || q.e || q.v || q.company || q.email || q.vc) {
        this.bootstrapFromUrl(q).catch(() => {
          this.bootError = "Failed to bootstrap from link.";
        });
      }
    },

    async bootstrapFromUrl(params) {
      let dec = null;
      if (params.t || params.token) {
        const raw = params.t || params.token;
        const plain = this.decryptFromUrl(raw);
        if (plain) {
          try {
            dec = JSON.parse(plain);
          } catch (err) {
            dec = null;
          }
        }
      }

      let company = "";
      let email = "";
      let vc = "";

      if (dec && typeof dec === "object") {
        company = (dec.company || dec.c || "").toString();
        email = (dec.email || dec.e || "").toString();
        vc = (dec.vc || dec.v || "").toString();
      } else if (params.c || params.e || params.v) {
        company = this.decryptFromUrl(params.c || "") || "";
        email = this.decryptFromUrl(params.e || "") || "";
        vc = this.decryptFromUrl(params.v || "") || "";
      } else {
        const qCompany = this.safeDecode(params.company || "");
        const qEmail = this.safeDecode(params.email || "");
        const qVc = this.safeDecode(params.vc || "");
        company = this.maybeDecrypt(qCompany);
        email = this.maybeDecrypt(qEmail);
        vc = this.maybeDecrypt(qVc);
      }

      const payload = {
        company: (company || "").trim(),
        email: (email || "").trim(),
        vc: (vc || "").trim(),
      };

      if (payload.email && this.isEmailFmt(payload.email)) {
        payload.email = payload.email.toLowerCase();
      }

      if (!(payload.company || payload.email || payload.vc)) return;

      await this.handleMagicLink(payload);
    },

    async handleMagicLink(payload) {
      const { company, email, vc } = payload;

      if (email) {
        this.signin.email = email;
      }

      let workspaceId = "";
      if (company) {
        const companySlug = company
          .toString()
          .trim()
          .replace(/\s+/g, "-")
          .toLowerCase();
        await this.$store.dispatch("company/fetchCompanyBySlug", {
          slug: companySlug,
        });
        const slugHit =
          this.getContactLoginSlug && this.getContactLoginSlug._id
            ? this.getContactLoginSlug
            : null;
        if (slugHit && slugHit._id) {
          workspaceId = slugHit._id;
        }
      }

      if (!workspaceId && email) {
        await this.$store.dispatch("company/fetchCompaniesByEmail", { email });
        const cmp = (s = "") => s.toString().replace(/\s+/g, "").toLowerCase();
        const list = this.getWorkspaceList || [];
        const chosen =
          list.find(
            (w) =>
              cmp(w?.slug || "") === cmp(company) ||
              cmp(w?.name || "") === cmp(company)
          ) || (Array.isArray(list) && list.length === 1 ? list[0] : null);
        workspaceId = chosen?._id || "";
      }

      if (!workspaceId) {
        this.currentForm = "VERIFIED";
        this.$notify({
          title: "Info",
          message:
            "Workspace not auto-detected from link. Please select it to continue.",
          type: "warning",
        });
        return;
      }

      this.signin.workspace = workspaceId;
      this.currentForm = "VERIFIED";

      if (vc) {
        this.otpFromLink = true;
        this.otp = vc;
        this.isForgotPassword = false;
        this.isSettedPassword = true;

        this.isDisabled = false;

        this.$notify({
          title: "Ready",
          message:
            "OTP detected from link. You can reset your password now, or resend a new OTP.",
          type: "success",
        });
        return;
      }

      const isEmail = this.isEmailFmt(email);
      const verifyPayload = {
        company_id: workspaceId,
        ...(isEmail ? { email } : { phone: email }),
      };

      await this.$store.dispatch(
        "applicationUsers/fetchForgotAndResendVerify",
        verifyPayload
      );

      if (this.getForgotAndResendVerify?.data?.status) {
        this.contactDetails = this.getForgotAndResendVerify.data;

        this.otpFromLink = false;
        this.isForgotPassword = false;
        this.isSettedPassword = true;

        this.startTimer();
        this.$notify({
          title: "Success",
          message:
            this.getForgotAndResendVerify?.message ||
            "OTP sent to your contact.",
          type: "success",
        });
      } else {
        const errMsg =
          this.getForgotAndResendVerifyError?.message ||
          "The verification link is invalid or expired.";
        this.$notify.error({ title: "Error", message: errMsg });

        this.currentForm = "VERIFIED";
        this.isSettedPassword = false;
      }
    },

    startTimer() {
      if (this.intervalId) clearInterval(this.intervalId);
      this.isDisabled = true;
      this.timer = 30;
      this.intervalId = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.isDisabled = false;
        }
      }, 1000);
    },

    async resendVerificationCode() {
      if (!this.signin.workspace) {
        this.$notify.error({
          title: "Missing workspace",
          message: "Please select a workspace first.",
        });
        return;
      }

      const recipient =
        (this.contactDetails &&
          (this.contactDetails.email || this.contactDetails.phone)) ||
        this.signin.email;

      if (!recipient) {
        this.$notify.error({
          title: "Error",
          message: "Cannot resend code: missing recipient (email or phone).",
        });
        return;
      }

      this.submitLoading = true;
      try {
        const payload = {
          company_id: this.signin.workspace,
          ...(this.isEmailFmt(recipient)
            ? { email: recipient }
            : { phone: recipient }),
        };

        await this.$store.dispatch(
          "applicationUsers/fetchForgotAndResendVerify",
          payload
        );

        if (this.getForgotAndResendVerify?.data?.status) {
          this.contactDetails = this.getForgotAndResendVerify.data;

          this.$notify({
            title: "Success",
            message:
              this.getForgotAndResendVerify?.message ||
              "OTP resent successfully!",
            type: "success",
          });

          this.startTimer();
        } else {
          this.$notify.error({
            title: "Error",
            message:
              this.getForgotAndResendVerifyError?.message ||
              "Error resending verification code.",
          });
        }
      } catch {
        this.$notify.error({
          title: "Error",
          message: "Something went wrong while resending verification code.",
        });
      } finally {
        this.submitLoading = false;
      }
    },

    changeViewInput() {
      this.isEmailOpted = !this.isEmailOpted;
    },

    async checkPassword() {
      this.passwordError = "";
      this.passwordErrors = [];

      if (!this.setPassword) {
        this.passwordErrors.push("Password is required");
        return;
      }

      this.password_rules.forEach((rule) => {
        if (!rule.regex.test(this.setPassword)) {
          this.passwordErrors.push(rule.message);
        }
      });

      if (!this.setPassword.length || !this.conformPassword.length) return;

      if (this.setPassword !== this.conformPassword) {
        this.passwordErrors.push("Password mismatch!");
        this.isSettedPassword = true;
        return;
      }

      if (this.passwordErrors.length) return;

      await this.$store.dispatch(
        "applicationUsers/fetchUserEmailVerifyDetails",
        {
          ...(this.contactDetails &&
            this.contactDetails._id && {
              contact_id: this.contactDetails._id,
            }),
          ...(this.signin && this.signin.email && { email: this.signin.email }),
          verification_code: this.otp,
          password: this.setPassword,
        }
      );

      if (this.getUserEmailVerifyDetails) {
        this.$notify({
          title: "Success",
          message: "Password Updated Successfully!",
          type: "success",
        });
        this.isSettedPassword = false;
        if (this.contactDetails?.email) {
          this.signin.email = this.contactDetails.email;
        }
        if (this.getUserEmailVerifyDetails?.data) {
          this.contactDetails = this.getUserEmailVerifyDetails.data;
        }
        this.$router.push({ path: "/signin/tenant" });
      } else {
        this.passwordErrors = [];
        this.passwordErrors.push(
          this.getUserEmailVerificationErrors?.message ||
            "Error while verifying"
        );
      }
    },

    async navigation() {
      if (this.getCompaniesByEmail?.status) {
        this.currentForm = "VERIFIED";
        this.signin.email = this.getEmail;

        const list = this.getWorkspaceList;
        if (Array.isArray(list) && list.length === 1) {
          this.signin.workspace = list[0]._id;
        }
      }
    },

    async verifyEmail(formType) {
      this.verification.email = (this.verification.email || "")
        .trim()
        .toLowerCase();
      if (!this.verification.email) {
        this.getErrors = { verification_email: "Email is required!" };
        return;
      }
      if (!this.isEmailValid) {
        this.getErrors = { verification_email: "Enter a valid email address!" };
        return;
      }

      this.getErrors = null;

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;
        this.submitLoading = true;
        await this.$store.dispatch("company/fetchCompaniesByEmail", {
          email: this.verification.email,
        });
        if (this.getCompaniesByEmail?.status) {
          this.currentForm = "VERIFIED";
          this.signin.email = this.getEmail;
        }
        this.submitLoading = false;
      });
    },

    async submitForm(formType, isForgot = false) {
      this.signin.email = this.normalizeLogin(this.signin.email);

      const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneFormat = /^(?:\+91|91)?\d{10}$/;

      if (!this.signin.email) {
        this.getErrors = { email: "Email or Mobile number is required!" };
        return;
      }
      if (!this.signin.workspace) {
        this.getErrors = { workspace: "Workspace (Company) is required!" };
        return;
      }

      const isEmail = emailFormat.test(this.signin.email);
      const isPhone = phoneFormat.test(this.signin.email);
      if (!isEmail && !isPhone) {
        this.getErrors = { email: "Enter a valid Email or Mobile number!" };
        return;
      }

      this.getErrors = null;

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;

        this.submitLoading = true;

        try {
          const verifyPayload = {
            company_id: this.signin.workspace,
            ...(isEmail
              ? { email: this.signin.email }
              : { phone: this.signin.email }),
          };

          await this.$store.dispatch(
            "applicationUsers/fetchForgotAndResendVerify",
            verifyPayload
          );

          this.loading = true;

          if (this.getForgotAndResendVerify?.data?.status) {
            this.resendDetails = this.getForgotAndResendVerify?.data || null;
            this.successMessages = "";
            this.contactDetails = this.getForgotAndResendVerify.data;
            this.loading = false;
            this.startTimer();
            this.$notify({
              title: "Success",
              message:
                this.getForgotAndResendVerify?.message ||
                "OTP sent to your email!",
              type: "success",
            });
            this.successMessages = this.getForgotAndResendVerify?.message;

            if (
              this.getForgotAndResendVerify?.statusCode ==
              "account_not_verified"
            ) {
              if (isForgot) {
                this.isForgotPassword = true;
              } else {
                this.isSettedPassword = true;
              }
            } else if (
              this.getForgotAndResendVerify?.statusCode == "reset_password"
            ) {
              this.isForgotPassword = false;
              this.isSettedPassword = true;
            }
          } else {
            this.loading = false;
            this.VerificationErrors =
              this.getForgotAndResendVerifyError?.message ||
              "Error while verifying";
          }
        } catch (error) {
          this.$notify.error({
            title: "Error",
            message: "Something went wrong during sign in.",
          });
        } finally {
          this.submitLoading = false;
        }
      });
    },

    goToBuilder() {
      this.$router.push({ path: "/signin/tenant" });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  color: #196392 !important;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
}

.full-width {
  width: 100%;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider .line {
  height: 1px;
  width: 100%;
  background-color: #ccc;
}

.divider-text {
  padding: 0 10px;
}

.password-input-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error {
  color: red;
}
.password-input-wrapper {
  position: relative;
  display: block; /* Ensure vertical layout */
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 78%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color, #007bff);
  user-select: none;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.forgot-password-link {
  /* font-size: 14px;
  color: #000000; */
  text-decoration: none;
  /* font-weight: bold; */
  cursor: pointer;
  margin: 4px 0;
}

.forgot-password-link:hover {
  text-decoration: underline;
}
.disabled {
  cursor: not-allowed;
}
.el-form-item {
  margin-bottom: 0px !important;
}
.d-flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
</style>
